var _animate;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfinity1S50Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      background: "transparent",
      display: "block",
      shapeRendering: "auto"
    },
    width: "84px",
    height: "54px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f8a500",
    strokeWidth: 8,
    strokeDasharray: "42.76482137044271 42.76482137044271",
    d: "M24.3 30C11.4 30 5 43.3 5 50s6.4 20 19.3 20c19.3 0 32.1-40 51.4-40 C88.6 30 95 43.3 95 50s-6.4 20-19.3 20C56.4 70 43.6 30 24.3 30z",
    strokeLinecap: "round",
    style: {
      transform: "scale(0.8)",
      transformOrigin: "50px 50px"
    }
  }, _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;1",
    values: "0;256.58892822265625"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity1S50Px);
export default __webpack_public_path__ + "static/media/Infinity-1s-50px.393f1610f5847462ff63427ab7afc27c.svg";
export { ForwardRef as ReactComponent };